// WARNING: DO NOT EDIT.  This file is automatically generated
// Written by aws-amplify-serverless-plugin/1.4.2 on 2021-02-17T05:02:15.447Z

const awsmobile = {
    aws_cloud_logic_custom: [
        {
            endpoint: 'https://m5d6ipv60a.execute-api.us-east-1.amazonaws.com/dev',
            name: 'ApiGatewayRestApi',
            region: 'us-east-1'
        }
    ],
    aws_cognito_identity_pool_id: 'us-east-1:10f1b6ba-f2b0-42d8-9710-a71c1183b24c',
    aws_cognito_region: 'us-east-1',
    aws_project_region: 'us-east-1',
    aws_user_pools_id: 'us-east-1_Y6ITTDfTW',
    aws_user_pools_web_client_id: '5svba2i02d5uc6osq0ufh8nho4'
};

export default awsmobile;
